import {createSelector, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {SearchParams} from '../../schema'
import {
  addDays,
  differenceInDays,
  formatISODate
} from '../../services/dateUtils'

const today = new Date()

const initialState: SearchParams = {
  location: '',
  propertyId: '',
  dateRange: {
    type: 'Specific',
    start: formatISODate(addDays(today, 1)),
    end: formatISODate(addDays(today, 2))
  },
  guests: 1,
  specialRates: {
    promoCode: '',
    corporateCode: '',
    hasAAA: false,
    hasAARP: false,
    hasGov: false,
    hasMilitary: false
  }
}

export const searchParamsSlice = createSlice({
  name: 'searchParams',
  initialState,
  reducers: {
    setSearchParams: (state, action: PayloadAction<SearchParams>) => {
      state = action.payload
      return state
    },
    clearSearchParams: state => {
      state = initialState
      return state
    }
  }
})

// selectors
export const selectSearchParams = (state: any): SearchParams => {
  return state?.searchParams
}

/**
 * Selects the number of nights based on the search date range.
 * Returns -1 if the date range is not specific or if dates are invalid.
 */
export const selectSearchNightCount = createSelector(
  selectSearchParams,
  searchParams => {
    const {dateRange} = searchParams
    const startDate = dateRange.start
    const endDate = dateRange.end

    if (dateRange.type === 'Specific' && startDate && endDate) {
      return differenceInDays(endDate, startDate)
    } else {
      return -1
    }
  }
)

// actions
export const {setSearchParams, clearSearchParams} = searchParamsSlice.actions

// reducer
export default searchParamsSlice.reducer
